/**
 * Tracking Events
 * This file is used to track events..
 * It listens to custom events and sends the data to Shopify's analytics.
 * All data should be prepared and sent in the format that Shopify's analytics expects.
 *
 * Namespace: tracking:event-name
 */

if (typeof window !== 'undefined' && window.addEventListener) {
  window.addEventListener('klaviyoForms', function (e) {
    if (e.detail.type === 'submit') {
      Shopify.analytics.publish('klaviyoFormSubmitted');
      window.dispatchEvent(new CustomEvent('klaviyoFormSubmitted'));
      // eslint-disable-next-line dot-notation
      Shopify.analytics.publish('Klar:signupEvent', {email: e.detail.metaData['$email']});
    }
  });
}

function publishShopifyEvent(shopifyEvent, productData) {
  const selectedProducts = Array.isArray(productData) ? productData : [productData];
  const trasnformedData = selectedProducts.map((variant) => ({
    id: variant.id,
    product_id: variant.productHandle, // handle instead of numeric product_id
    name: variant.title,
    price: (variant.price / 100).toFixed(2),
    compare_at_price: variant.compare_at_price ? (variant.compare_at_price / 100).toFixed(2) : null,
    options: variant.options,
    image: variant.featured_image,
  }));

  Shopify.analytics.publish(shopifyEvent, {productDetail: trasnformedData});
  window.dispatchEvent(new CustomEvent(shopifyEvent, {detail: trasnformedData}));
}

export {publishShopifyEvent};
